import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import Assets from 'app/configs/assetConfigs'

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.6rem',
  },
  placeName: {
    color: theme.palette.notificationPreview.brownGrey,
  },
  directionRtl: {
    direction: 'rtl',
  },
}))

const NotificationEventPlace = ({ title, placeName }) => {
  const classes = useStyles()
  return (
    <div className="flex flex-col mt-8 mx-16" dir="auto">
      <span className={clsx(classes.title, 'font-bold break-words')}>
        {title}
      </span>
      <div className="flex mt-6">
        <img
          className="h-16 w-12 ltr:mr-6 rtl:ml-6"
          src={Assets.notiPreviewCard.mapPin}
          alt="map pin"
        />
        <span className={clsx(classes.placeName, 'font-base truncate')}>
          {placeName}
        </span>
      </div>
    </div>
  )
}

export default NotificationEventPlace
